import React from "react";

export const Page12English = () => {
  return (
    <div className="page-container">
      <h1>Temple Worship Methods</h1>
      <h1>Ten Commandments that devotees should follow themselves:</h1>
      <p>1. One should worship all the deities in the temple.</p>
      <p>2. One should walk slowly around the prakaram on the right side.</p>
      <p>
        3. One should avoid burning betel leaves, applying powder, smoking
        tobacco, smoking, and using drugs while going around the temple. One
        should not go around the temple even after eating anything.
      </p>
      <p>4. One should not enter the temple wearing a turban, hat, or shoes.</p>
      <p>5. One should join both hands together and worship.</p>
      <p>
        6. One should not talk nonsense with those accompanying them and talk in
        a way that would hurt the devotees' feelings.
      </p>
      <p>7. One should not enter the temple without taking a bath.</p>
      <p>
        8. One should not have darshan of the Lord at night when there is no
        lamp.
      </p>
      <p>9. One should not sit on a high seat inside the temple</p>
      <p>
        10. The prasadam (vibhuti kumkuma) offered in the temple should be
        properly received and used.
      </p>
    </div>
  );
};
